import { useEffect, useMemo, useState } from 'react'

import { AsyncContent } from 'core/ui/async-content/AsyncContent'
import { Section } from 'core/ui/components/section/Section'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { OfferCard, CONTEXTS } from 'legacy/containers/LoadsPage/OfferCard/OfferCard'

import { type Load } from 'tender/domain/Load'
import { TenderCard } from 'tender/ui/TenderCard'

import { usePendingResponses } from '../hooks/usePendingResponses'

export type PendingResponsesProps = {
  onChange?: (length: number) => {}
}

export function PendingResponses({ onChange }: PendingResponsesProps) {
  const abortController = useAbortController()
  const [confirmedTenders, setConfirmedTenders] = useState<Array<Load>>([])
  const { pendingResponses, pendingResponsesStatus, fetchPendingResponses } =
    usePendingResponses(abortController)

  const filteredPendingResponses = useMemo(() => {
    return pendingResponses.filter(pendingResponse => {
      if (pendingResponse.type === 'tender' && confirmedTenders.includes(pendingResponse.value)) {
        return false
      }
      return true
    })
  }, [confirmedTenders, pendingResponses])

  function handleTenderAction(load: Load) {
    setConfirmedTenders(prevConfirmedTenders => {
      return [...prevConfirmedTenders, load]
    })
  }

  useEffect(() => {
    fetchPendingResponses()
  }, [fetchPendingResponses])

  useEffect(() => {
    if (onChange) {
      onChange(filteredPendingResponses.length)
    }
  }, [filteredPendingResponses.length, onChange])

  return (
    <AsyncContent
      status={pendingResponsesStatus}
      count={filteredPendingResponses.length}
      loadingState={null}
    >
      <Section title="Pending responses" subtitle="Accept the offers below before it expires!">
        {filteredPendingResponses.map(pendingResponse => {
          if (pendingResponse.type === 'tender') {
            const load = pendingResponse.value
            return (
              <TenderCard
                key={load.id}
                load={load}
                onAccept={handleTenderAction}
                onReject={handleTenderAction}
              />
            )
          } else {
            const offer = pendingResponse.value
            return (
              <OfferCard key={offer.uuid} loadOffer={offer} context={CONTEXTS.PENDING_RESPONSES} />
            )
          }
        })}
      </Section>
    </AsyncContent>
  )
}
